import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
const queryString = require('query-string');


class TemplateCarouselBasicCenterBadge extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image: "",
            title: "",
            error: false
        };
    };

    componentWillMount() {
        try {
            let url = window.location.search;
            let data = queryString.parse(url);
            this.setState({
                image: data.image,
                title: data.title,
            })
        }catch (e) {
            this.setState({
                error: true
            });
        }
    }

    render() {
        return(
            <div style={{backgroundImage: 'url('+this.state.image+')'}} className={Styles.container}>
                <div className={Styles.containerTextBox}>
                    {this.state.title}
                </div>
            </div>
        )
    }
}

export default TemplateCarouselBasicCenterBadge;


// WEBPACK FOOTER //
// ./src/templates/carousel/basic/center-badge/component.js